export type CachePolicy = {
    enabled: true;
    ttlMs?: number; // por defecto 3h
};

export const DEFAULT_TTL_MS = 3 * 60 * 60 * 1000;

export const CACHEABLE_MODELS: Record<string, CachePolicy> = {
    // Opt-in aquí:
    // Product: { enabled: true, ttlMs: 3 * 60 * 60 * 1000 },
    Provider: { enabled: true, ttlMs: 6 * 60 * 60 * 1000 },
    Client: { enabled: true, ttlMs: 3 * 60 * 60 * 1000 },
    Currency: { enabled: true, ttlMs: 3 * 60 * 60 * 1000 },
    Price: { enabled: true, ttlMs: 12 * 60 * 60 * 1000 },
    Saleman: { enabled: true, ttlMs: 12 * 60 * 60 * 1000 },
    ActivityCode: { enabled: true, ttlMs: 12 * 60 * 60 * 1000 },
    BankAccount: { enabled: true, ttlMs: 12 * 60 * 60 * 1000 },
    CustomField: { enabled: true, ttlMs: 12 * 60 * 60 * 1000 },
    InvoiceTemplate: { enabled: true, ttlMs: 12 * 60 * 60 * 1000 },
    Zone: { enabled: true, ttlMs: 12 * 60 * 60 * 1000 },
    Suscription: { enabled: true, ttlMs: 12 * 60 * 60 * 1000 },
    Category: { enabled: true },
    Role: { enabled: true, ttlMs: 24 * 60 * 60 * 1000 },
    ShippingProvider: { enabled: true, ttlMs: 3 * 60 * 60 * 1000 },
};